<div class="help-dialog">
  <div class="help-dialog-header d-flex align-items-center justify-content-between">
    <div class="help-title">Recording Start Time rules</div>
    <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="close()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="help-dialog-body">
    <div class="mb-3">
      <div class="section-title">How scheduling works</div>
      <div class="text-muted">
        Choose when the recording should begin. The task runs in backend and will start automatically at the scheduled time.
      </div>
    </div>

    <div class="mb-3">
      <div class="section-title">Allowed time window</div>
      <ul class="text-muted mb-0">
        <li><strong>Not earlier than the current minute</strong> (seconds are ignored).</li>
        <li><strong>Not later than 7 days from the current minute</strong> (inclusive).</li>
      </ul>
    </div>

    <div class="mb-3">
      <div class="section-title">Important notes</div>
      <ul class="text-muted mb-0">
        <li>Time is selected in your <strong>local timezone</strong>.</li>
        <li>If you schedule very soon (e.g., within ~1 minute), the system may start the task immediately.</li>
        <li>If you choose an out-of-range time, the UI will show a warning and keep the <strong>previous value</strong> (your change will not be applied).</li>
        <li>After an invalid change, <strong>Submit the Task</strong> is disabled until you select a valid time.</li>
        <li>When you click <strong>Submit the Task</strong>, the time is validated again. If invalid, the job will not be submitted.</li>
      </ul>
    </div>

    <div class="mb-1">
      <div class="section-title">Examples</div>
      <div class="text-muted">
        <div><strong>Example A:</strong> Now is 10:23:45 → earliest allowed is <code>10:23</code>.</div>
        <div><strong>Example B:</strong> If you try to set 10:22 → it will be rejected, the previous time will remain, and Submit will be disabled until you choose a valid time.</div>
        <div><strong>Example C:</strong> Now is Jan 1, 10:00 → latest allowed is Jan 8, 10:00.</div>
      </div>
    </div>
  </div>
</div>


